import { Link } from 'react-router-dom';

const Nav = ({ search, setSearch }) => {
    return (
        <nav className="Nav">
            <form className="searchForm" onSubmit={(e) => e.preventDefault()}>
                <label htmlFor="search">Search Notifications</label>
                <input
                    id="search"
                    type="text"
                    placeholder="Search Notifications"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </form>
            <ul>
                <li><Link to="">Notifications</Link></li>
                <li><a href="/new">Add notification</a></li>
            </ul>
        </nav>
    )
}

export default Nav